import React from "react";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
} from "recharts";

function TaChartSimple(props) {
  const data = [
    {
      name: "",
      uv: 3000,
      pv: 1398,
      amt: 2210
    },
    {
      name: "",
      uv: 2000,
      pv: 9800,
      amt: 2290
    },
    {
      name: "",
      uv: 1890,
      pv: 4800,
      amt: 2181
    }
  ];

  return (
    <ResponsiveContainer>
      <div style={{ height: "150px" }}>
        <BarChart
          style={{ display: "inline-block" }}
          width={100}
          height={125}
          data={data}
        >
          <Bar dataKey="pv" fill={props.color} />
        </BarChart>
      </div>
    </ResponsiveContainer>
  );
}
export default TaChartSimple;



// WEBPACK FOOTER //
// ./src/components/Charts/BarChartSimple.js